import { connect } from "react-redux";
import { CheckThongTinKh } from "components/CheckThongTinKh";
import { getListCheckThongTinKh } from "actions/CheckThongTinKh";

const mapStateToProps = (state) => ({
  checkthongtinkh: state.checkthongtinkh,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  getListCheckThongTinKh: (dataSearch) =>
    dispatch(getListCheckThongTinKh(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckThongTinKh);
